module.exports = __webpack_public_path__ + "img/ignis-logo-no-bg.082b950a.png";